import { useEffect, useRef } from 'react'

import { DataField } from '@formily/core'
import { connect, mapReadPretty, useField, useForm } from '@formily/react'
import { Input as AntdInput, InputRef } from 'antd'

import { useMergedRef } from '@eastcoal/common/hooks/useMergedRef'

import { generateControlName } from '../../utils/generateControlName'

import { ON_INPUT_MOUNT } from './effects/onInputMount'
import { InputProps } from './interface'

const Component = ({ ref, onChange, ...restProps }: InputProps) => {
  const form = useForm()
  const field = useField<DataField>()
  const inptRef = useRef<InputRef>(null)
  const mergedRef = useMergedRef<InputRef>(inptRef, ref)

  useEffect(() => {
    form.notify(ON_INPUT_MOUNT, {
      form,
      field,
      ref: inptRef
    })
  }, [field, form, inptRef])

  useEffect(() => {
    if (inptRef.current) {
      const formName = inptRef.current.input?.form?.name ?? ''
      if (inptRef.current.input) {
        inptRef.current.input.name = generateControlName({ field, formName })
      }
    }
  }, [field])

  return (
    <AntdInput
      ref={mergedRef}
      allowClear
      autoComplete='on'
      onChange={e => onChange?.(e.target.value)}
      {...restProps}
    />
  )
}

export const Input = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
